import React from "react";
import { object, func, string, bool } from "prop-types";
import { connect } from "react-redux";
import { LoadMoreCollectionStories } from "@quintype/components";
import get from "lodash/get";

import CustomStoryCard2 from "../../../molecules/CustomStoryCard2";

import { setLoading } from "../../../helper/actions";

import "./organism1.m.css";

const Organism1 = ({ collection, showTagInWebsite, setLoading, publisherAttributes }) => {
  const numStoriesToLoad = 6;
  const storyList = collection.items.filter((item) => item.type === "story").map((item) => item.story);

  if (!(storyList && storyList.length)) {
    return null;
  }

  const MoreCollectionStories = (params) => {
    const { stories } = params;
    const firstSetStories = stories.slice(0, 3);

    return (
      <div>
        {firstSetStories.map((story, index) => (
          <CustomStoryCard2
            key={index}
            story={story}
            isImageCaptionRequired={false}
            isSection={false}
            isExcerpt={true}
            isMetaDataShown={false}
            isTagShown={showTagInWebsite}
            aspectRatio={[3, 2]}
            imageType="image3x2"
            headlineType={27}
            subHeadlineType={6}
            widths={[200]}
            updatedFont={true}
          />
        ))}
      </div>
    );
  };

  return (
    <LoadMoreCollectionStories
      template={(e) => MoreCollectionStories(e, numStoriesToLoad)}
      collectionSlug={collection.slug}
      data={Object.assign(
        {},
        { collection },
        { stories: [...storyList.map((story) => story).slice(0, 10)] },
        { storiesPerPage: numStoriesToLoad }
      )}
      numStoriesToLoad={numStoriesToLoad}
      params={{ "item-type": "story" }}
    />
  );
};

const mapDispatchToProps = (dispatch) => ({
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
});

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

Organism1.propTypes = {
  collection: object.isRequired,
  setLoading: func,
  publisherAttributes: object,
  captionStyle: string,
  showTagInWebsite: bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(Organism1);
